import React from 'react'

export default function Advertisements() {
  return (
    <div>Advertisements</div>
  )
}
